import { render, staticRenderFns } from "./HotelSidebar.vue?vue&type=template&id=0a559106&"
import script from "./HotelSidebar.vue?vue&type=script&lang=js&"
export * from "./HotelSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports